// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"149":"be974019","635":"f20da6c0"}[chunkId] + ".chunk.js");